import { render, staticRenderFns } from "./commInfo.vue?vue&type=template&id=28aa1768&"
import script from "./commInfo.vue?vue&type=script&lang=js&"
export * from "./commInfo.vue?vue&type=script&lang=js&"
import style0 from "./commInfo.vue?vue&type=style&index=0&id=28aa1768&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports